<template>
  <div class="p-4">
    <SmartCheckboxGroup
      v-model="form.devices"
      :options="availableDevices"
      display-field="name"
      value-field="id"
      value-type="string"
      class="flex flex-col"
    >
      <template #default="{ item }">
        <el-checkbox :label="item.key">
          <i class="el-icon-cpu mr-1" />
          {{ item.value }}
          <el-badge :value="item.rawData.type" class="ml-2" />
        </el-checkbox>
      </template>
    </SmartCheckboxGroup>
    <div class="mt-4 flex gap-2">
      <el-button type="primary" @click="showSelected">显示选中数据</el-button>
      <el-button @click="setSelected(['2'])">只选Device B</el-button>
      <el-button @click="setSelected(['1', '2', '3'])">全选</el-button>
      <el-button @click="setSelected([])">清空选择</el-button>
    </div>
  </div>
</template>

<script>
import SmartCheckboxGroup from "@/components/SmartControls/SmartCheckboxGroup.vue";
export default {
  name: "SmartCheckboxGroupPage",
  components: {
    SmartCheckboxGroup,
  },
  data() {
    return {
      availableDevices: [
        {
          id: "1",
          name: "Device A",
          type: "Type 1",
        },
        {
          id: "2",
          name: "Device B",
          type: "Type 2",
        },
        {
          id: "3",
          name: "Device C",
          type: "Type 3",
        },
      ],
      form: {
        devices: ["1", "3"],
      },
    };
  },
  methods: {
    showSelected() {
      const selected = this.availableDevices.filter((d) =>
        this.form.devices.includes(d.id)
      );
      this.$alert(
        `<pre>${JSON.stringify(selected, null, 2)}</pre>`,
        "选中数据",
        {
          dangerouslyUseHTMLString: true,
        }
      );
    },
    setSelected(ids) {
      this.form.devices = ids;
    },
  },
};
</script>
